import React, { useState } from 'react';
import { Bell, ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Header = ({ title }) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('user');
        navigate('/login');
    };

    return (
        <header className="header">
            <div className="header-title">{title}</div>
            <div className="header-actions">
                <button className="icon-btn">
                    <Bell size={20} />
                </button>
                <div className="user-profile" style={{ position: 'relative' }}>
                    <div
                        className="avatar-container"
                        onClick={() => setShowDropdown(!showDropdown)}
                        style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                    >
                        <div className="avatar"></div>
                        <ChevronDown size={16} />
                    </div>

                    {showDropdown && (
                        <div className="dropdown-menu" style={{
                            position: 'absolute',
                            top: '100%',
                            right: 0,
                            backgroundColor: 'white',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                            borderRadius: '4px',
                            padding: '8px 0',
                            zIndex: 1000,
                            minWidth: '120px'
                        }}>
                            <div
                                className="dropdown-item"
                                onClick={() => {
                                    setShowDropdown(false);
                                    setShowLogoutConfirm(true);
                                }}
                                style={{
                                    padding: '8px 16px',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s'
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                            >
                                Đăng xuất
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {showLogoutConfirm && (
                <div className="modal-overlay" style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 2000
                }}>
                    <div className="modal-content" style={{
                        backgroundColor: 'white',
                        padding: '24px',
                        borderRadius: '8px',
                        maxWidth: '400px',
                        width: '100%'
                    }}>
                        <h3 style={{ marginTop: 0 }}>Xác nhận đăng xuất</h3>
                        <p>Bạn có chắc chắn muốn đăng xuất không?</p>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', marginTop: '24px' }}>
                            <button
                                onClick={() => setShowLogoutConfirm(false)}
                                style={{
                                    padding: '8px 16px',
                                    border: '1px solid #d9d9d9',
                                    borderRadius: '4px',
                                    backgroundColor: 'white',
                                    cursor: 'pointer'
                                }}
                            >
                                Hủy
                            </button>
                            <button
                                onClick={handleLogout}
                                style={{
                                    padding: '8px 16px',
                                    border: 'none',
                                    borderRadius: '4px',
                                    backgroundColor: '#1890ff',
                                    color: 'white',
                                    cursor: 'pointer'
                                }}
                            >
                                Đăng xuất
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;
